import React from "react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import BugsnagPerformance from "@bugsnag/browser-performance";

const releaseStage = process.env.REACT_APP_RELEASE_STAGE || process.env.NODE_ENV;
const appVersion = process.env.REACT_APP_APP_VERSION;

const addRuntimeMetadata = (event) => {
  if (typeof window === "undefined") {
    return;
  }

  event.context = window.location.pathname || event.context;
  event.addMetadata("app", {
    href: window.location.href,
    path: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
  });
  event.addMetadata("device", {
    language: navigator.language,
    online: navigator.onLine,
    userAgent: navigator.userAgent,
    viewport: `${window.innerWidth}x${window.innerHeight}`,
  });
};

Bugsnag.start({
  apiKey: 'eaba542b07b3891ce1c00bc8c0d0f752',
  plugins: [new BugsnagPluginReact(React)],
  releaseStage,
  appVersion: appVersion || undefined,
  generateAnonymousId: true,
  onError: (event) => {
    addRuntimeMetadata(event);
  },
});
BugsnagPerformance.start({apiKey: 'eaba542b07b3891ce1c00bc8c0d0f752' });

const bugsnagReactErrorBoundary = Bugsnag.getPlugin("react")?.createErrorBoundary(React);

const notifyStartupError = (details) => {
  if (!details) {
    return;
  }

  const error = new Error(details.message || "Pre-app startup error");

  if (details.stack) {
    error.stack = details.stack;
  }

  Bugsnag.notify(error, (event) => {
    event.context = "startup";
    event.addMetadata("startup", details);
    addRuntimeMetadata(event);
  });
};

export {
  addRuntimeMetadata,
  bugsnagReactErrorBoundary,
  notifyStartupError,
  releaseStage,
};

export default Bugsnag;
